import Mutations from '../../odata/mutations';

export default {
  ...new Mutations('agreement'),
  ...new Mutations('agreements'),
  ...new Mutations('summary'),
  ...new Mutations('agreementHeaders'),
};
